'use client';

import type { DobiSymbolName } from './DobiSymbol';
import styles from './DobiNavigationMark.module.css';

const colors: Record<DobiSymbolName, string> = {
  explore: '#242731',
  projects: '#345FF1',
  assets: '#EA5637',
  kagemane: '#4ABDE9',
  virtualTryOn: '#7A41E8',
  outfitExtension: '#139B70',
  silhouetteExtension: '#E7398D',
  whiteBackground: '#697386',
  lookbook: '#D49B08',
};

/** Flat product marks: one ink per mark, with detail defined by negative space. */
export function DobiNavigationMark({ name }: { name: DobiSymbolName }) {
  return <svg className={styles.mark} width="32" height="32" viewBox="0 0 32 32" fill="none" color={colors[name]} aria-hidden="true" focusable="false" data-navigation-mark={name}>
    {name === 'explore' && <>
      <ellipse cx="16" cy="16" rx="13" ry="6" transform="rotate(-45 16 16)" stroke="currentColor" strokeWidth="3" />
      <ellipse cx="16" cy="16" rx="13" ry="6" transform="rotate(45 16 16)" stroke="currentColor" strokeWidth="3" />
      <circle cx="16" cy="16" r="3" fill="currentColor" />
    </>}
    {name === 'projects' && <path fillRule="evenodd" d="M3 5h9l4 4h13v17H3V5Zm4 8v3h18v-3H7Z" fill="currentColor" clipRule="evenodd" />}
    {name === 'assets' && <path fillRule="evenodd" d="M3 3h26v26H3V3Zm5 20h16l-5-8-4 5-3-3-4 6Zm15-11a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z" fill="currentColor" clipRule="evenodd" />}
    {name === 'kagemane' && <>
      <path fillRule="evenodd" d="M13 3h12a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H13a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5Zm3 6v10l9-5-9-5Z" fill="currentColor" clipRule="evenodd" />
      <path d="M2 10h3v16h17v3H7a5 5 0 0 1-5-5V10Z" fill="currentColor" />
    </>}
    {name === 'virtualTryOn' && <path fillRule="evenodd" d="m10 3-8 6 4 7 4-2v15h12V14l4 2 4-7-8-6c0 3-2 5-6 5s-6-2-6-5Zm4 10v12h4V13h-4Z" fill="currentColor" clipRule="evenodd" />}
    {name === 'outfitExtension' && <>
      <path d="M12 8a4 4 0 1 1 7 2.6L16 13v3" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M16 15 3 24h26L16 15Z" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
      <path d="M11 29h10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </>}
    {name === 'silhouetteExtension' && <path fillRule="evenodd" d="M10 3h4v5h4V3h4l2 7-5 6 9 13H4l9-13-5-6 2-7Zm3 18-2 4h10l-2-4h-6Z" fill="currentColor" clipRule="evenodd" />}
    {name === 'whiteBackground' && <>
      <path d="M11 3H3v8m18-8h8v8M3 21v8h8m18-8v8h-8" stroke="currentColor" strokeWidth="3" />
      <path d="M16 8c5 0 8 4 8 8s-3 8-8 8H8V16c0-5 3-8 8-8Z" fill="currentColor" />
    </>}
    {name === 'lookbook' && <path d="M3 4c4-1 7 0 11 3v21c-4-3-7-4-11-3V4Zm26 0c-4-1-7 0-11 3v21c4-3 7-4 11-3V4Z" fill="currentColor" />}
  </svg>;
}
